import React from 'react';

import { ArticleHeading5, ArticleHeading4, UIText2, useDeviceType } from '@cian/ui-kit';
import styles from './styles.css';
import { IRequirement } from 'shared/types/common/offer';
import { ConditionalWrapper } from '@cian/conditional-component';

export interface IRequirementsProps {
  requirements: IRequirement[];
}

export const Requirements: React.FC<IRequirementsProps> = props => {
  const { requirements } = props;
  const isDesktop = useDeviceType() === 'desktop';

  return (
    <ul className={styles['list']}>
      {requirements.map((el, index) => {
        return (
          <li key={index}>
            <ConditionalWrapper if={isDesktop} ThenComponent={ArticleHeading5} ElseComponent={ArticleHeading4}>
              {el.title}
            </ConditionalWrapper>
            {el.text ? <UIText2>{el.text}</UIText2> : null}
          </li>
        );
      })}
    </ul>
  );
};
